import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { getformUdinAnalytics } from "api/services/automation/dashboard-tan";
import { useQuery } from "react-query";
import { ResType } from "types";
import { StyledTaskBox } from "views/dashboard/OrgDashboard/styles";
import { useNavigate } from "react-router-dom";
import { Bar,LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis,BarChart } from "recharts";
// import { colors } from "views/tasks/board/utils";
import Loader from "components/Loader";
// import { BarChart } from '@mui/x-charts';
import { useState } from "react";
import { getAutFinancialYears, getUdinAutFinancialYears } from "utils/getFinancialYears";
import { getCurrentFinancialYear } from "pages/atom-pro/Tan/constants";


function TanFormsUdinAnalytics() {
  const navigate = useNavigate();
  const [financialYear, setFinancialYear] = useState(getCurrentFinancialYear(new Date()));

  const handleFinancialYearChange = (e) => {
    setFinancialYear(e.target.value)
  };
  
  const { data, isLoading }: ResType = useQuery(
    ["form-udin-analytics", financialYear],
    getformUdinAnalytics
  );


  const translations = {
    total: 'Total Forms',
    udinCompleted: 'UDIN Completed',
    udinPending: 'UDIN Pending',
    udinNotApplicable: 'UDIN Not Applicable',
} as const;

  const analyticsData = [
    {
      type: "Original/Regular",
      total: data?.data?.originalForms?.totalOriginalForms,
      udinCompleted: data?.data?.originalForms?.udinCompleted,
      udinPending: data?.data?.originalForms?.udinPending,
      udinNotApplicable: data?.data?.originalForms?.udinNotApplicable,
    },
    {
      type: "Revised/Correction",
      total: data?.data?.revisedFroms?.totalRevisedForms,
      udinCompleted: data?.data?.revisedFroms?.udinCompleted,
      udinPending: data?.data?.revisedFroms?.udinPending,
      udinNotApplicable: data?.data?.revisedFroms?.udinNotApplicable,
    },
    {
      type: "NA",
      total: data?.data?.notApplicableForms?.totalNotApplicableForms,
      udinCompleted: data?.data?.notApplicableForms?.udinCompleted,
      udinPending: data?.data?.notApplicableForms?.udinPending,
      udinNotApplicable: data?.data?.notApplicableForms?.udinNotApplicable,
    },
  ];

 function addLabels<T extends { dataKey: keyof typeof translations }>(series: T[]) {
    return series.map((item) => ({
        ...item,
        label: translations[item.dataKey],
        valueFormatter: (v: number | null) => (v ? `${v}` : '0'),
    }));
}

const handleClick = (params,type) => {
 
    
    // Example navigation based on type
    navigate("/atom-pro/income-tax-tan/forms", {
      state: {
        type: params.type,
        udinType:type,
        financialYear: financialYear,
        filingType:params.type
      },
    });
  };
  const formatTooltip = (value: any, name: string) => {
    return [`${value}`, translations[name as keyof typeof translations] || name];
  };
  if (isLoading) return <Loader />;


  return (
    <Box>
      <StyledTaskBox>
        <header style={{ backgroundColor: "#e6f2ff" }}>
          <Box display="flex" gap={1} width={"95%"}>
            <Typography variant="h6">UDIN Analytics</Typography>
          </Box>
          <Box>
            <TextField
              name="financialYear"
              value={financialYear}
              onChange={handleFinancialYearChange}
              size="small"
              label="Financial Year"
              select
              sx={{ width: "250px" }}
            >
              <MenuItem key={""} value={""}>
                ALL
              </MenuItem>
              {getUdinAutFinancialYears().map((year: string) => (
                <MenuItem key={year} value={year.split("-")[0]}>
                  {year}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </header>

        <main>
          <ResponsiveContainer width="95%" height={350}>
            {/* <BarChart
              dataset={analyticsData}
              series={addLabels([
                { dataKey: 'total', stack: 'a' },
                { dataKey: 'udinCompleted', stack: 'b' },
                { dataKey: 'udinPending', stack: 'b' },
                { dataKey: 'udinNotApplicable', stack: 'c' },
            ])}
              xAxis={[{ scaleType: "band", dataKey: "type" }]}
              slotProps={{ legend: { hidden: true } }} 
              width={600}
              height={350} 
            /> */}
              <BarChart data={analyticsData}>
              <XAxis dataKey="type" fontSize={12} style={{fontWeight: "bold"}}/>
              <YAxis dataKey="total" fontSize={11} style={{fontWeight: "bold"}}/>
                 <Tooltip
                formatter={formatTooltip}
                labelStyle={{  fontWeight: "bold", fontSize: 14 }}
                itemStyle={{fontSize: 12,fontWeight: "bold" }}
                cursor={{ fill: "transparent" }}
              />
              <Bar dataKey="total"  fill="#0D47A1" barSize={15}  cursor='pointer' onClick={(v) => handleClick(v,null)}>
              </Bar>
              <Bar dataKey="udinNotApplicable" fill="#ffc658" barSize={15}  cursor='pointer' onClick={(v) => handleClick(v,'UDIN_NOT_APPLICABLE')}>
              </Bar>
              <Bar dataKey="udinCompleted" stackId="a" fill="#82ca9d" barSize={15} cursor='pointer' onClick={(v) => handleClick(v,'UDIN_COMPLETED')}>
              </Bar>
              <Bar dataKey="udinPending"  stackId="a" fill="#8884d8" barSize={15}  cursor='pointer' onClick={(v) => handleClick(v,'UDIN_PENDING')}>
              </Bar>
              </BarChart>
          </ResponsiveContainer>
        </main>
      </StyledTaskBox>
    </Box>
  );
}

export default TanFormsUdinAnalytics;
